import React, { useState } from "react";
import { CardPicker } from "./CardPicker";
import { usePicker } from "../Elements/PickerContext";
import { useNodeActions } from "../../hook/useNodeActions";
import { useSelection } from "../SelectionContext";

export function AddCardZone({ sectionId, containerId, index,page, setPage }) {
  const { addCardFromTemplateAction } = useNodeActions(page, setPage);
  const { activePicker, setActivePicker } = usePicker();
  const { setSelectedNodeId } = useSelection();

  const key = `${sectionId}-${containerId}-card-${index}`;
  const isActive = activePicker === key;

  function onSelect(template) {
    console.log(template)
    const cardId = addCardFromTemplateAction(sectionId, containerId, template, index);

    setActivePicker(null);
    setSelectedNodeId(cardId);
  }

  return (
    <div
      style={{width:"20px",
        height: "140px",
        background: isActive ? "#1A73E8" : "transparent",
        margin: "10px 0",
        cursor: "pointer",
        position: "relative"
      }}
        onMouseEnter={(e) => {
        e.currentTarget.style.background = "#1A73E8";
        e.currentTarget.style.height = "140px";
        
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "transparent";
        e.currentTarget.style.height = "95px";
        
      }}
      onClick={(e) => {
        e.stopPropagation();
        setActivePicker(isActive ? null : key);
      }}
    >
      {isActive && (
        <div style={{ position: "absolute", top: "20px" }}>
          <CardPicker onSelect={onSelect} />
        </div>
      )}
    </div>
  );
}
